module.exports = __webpack_public_path__ + "00f0e2a71243e6272ac174c4bed633d6.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/6_column_xlarge_x1/public/games/coh_image_3.png
// module id = 489
// module chunks = 0